import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import { Button } from "@mui/material";
import { getCommissionPayment } from "../../store/reducers/affiliateReducer";
import searchicon from "../../assets/icons/searchIcon.svg";
import calendarIcon from "../../assets/icons/calendar.svg";
import PaginationComponent from "../../utilities/Pagination";
import TickIcon from "../../assets/icons/tick-close.svg";
import crossIcon from "../../assets/icons/circle-close.svg";
import progressIcon from "../../assets/icons/progress-cricle.svg";
import dayjs from "dayjs";
import Loader from "react-spinners/ClipLoader";
import MobileTabs from "../../reusableComponents/MobileTabs/MobileTabs";

const CommissionPayment = () => {
  const dispatch = useDispatch();
  const { commission_payment } = useSelector((state) => state.affiliate);
  const selectedAffiliate = useSelector(
    (state) => state.affiliate.selectedAffiliate
  );

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const rowsPerPage = pageSize;
  const [statusFilter, setStatusFilter] = useState("All");
  const loader = useSelector((state) => state.loader.is_loading);
  const [open, setOpen] = useState(loader);
  useEffect(() => {
    setOpen(loader);
  }, [loader]);

  useEffect(() => {
    dispatch(
      getCommissionPayment(
        currentPage,
        rowsPerPage,
        selectedAffiliate,
        search,
        statusFilter
      )
    );
  }, [
    dispatch,
    currentPage,
    search,
    statusFilter,
    rowsPerPage,
    selectedAffiliate,
    statusFilter,
  ]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFilterChange = (newFilter) => {
    setStatusFilter(newFilter);
    setCurrentPage(1);
  };

  const formatDate = (dateString) =>
    dayjs(dateString).format("DD MMM , YYYY HH:MM");

  // Format dollar amount
  const dollarUS = (amount) => `$${parseFloat(amount)?.toFixed(2)}`;

  // Columns configuration for the table
  const columns = [
    {
      dataField: "created_at",
      text: "Date",
      formatter: (cell) => `${formatDate(cell)}`,
    },
    {
      dataField: "affiliate_email",
      text: "Affiliate Email",
    },
    {
      dataField: "commission_percentage",
      text: "Commission (%)",
      formatter: (cell) => cell && cell.toFixed(2),
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (cell) => dollarUS(cell),
    },
    {
      dataField: "promo_code",
      text: "Promo Code",
    },
    {
      dataField: "payment.payment_id",
      text: "Payment ID",
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell) => (
        <div
          className={
            cell === "Paid"
              ? "StatusPassed"
              : cell === "Failed"
              ? "StatusFailed"
              : "StatusProgress"
          }
        >
          {cell === "Paid" ? (
            <img src={TickIcon} alt="" style={{ marginRight: "6px" }} />
          ) : cell === "Failed" ? (
            <img src={crossIcon} alt="" style={{ marginRight: "6px" }} />
          ) : (
            <img src={progressIcon} alt="" style={{ marginRight: "6px" }} />
          )}
          {cell}
        </div>
      ),
    },
  ];

  const totalPages = commission_payment?.count
    ? Math.ceil(commission_payment?.count / rowsPerPage)
    : 0;

  const filteredData = commission_payment?.results || [];

  const [activeTab, setActiveTab] = useState(statusFilter);

  console.log(activeTab, statusFilter, "aaaaaaaccccc");

  const tabItems = [
    {
      name: "All",
      value: "All",
    },
    {
      name: "Paid",
      value: "Paid",
    },
    {
      name: "Pending",
      value: "Pending",
    },
    {
      name: "Failed",
      value: "Failed",
    },
  ];

  useEffect(() => {
    setStatusFilter(activeTab);
  }, [activeTab]);

  return (
    <div id="commission-payment-table">
      <div className="table_header">
        <div className="table_header_left">
          <div className="search_bar_wrapper">
            <img src={searchicon} alt="searchicon" />
            <input
              type="text"
              style={{borderRadius:"0px"}}
              className="search_input"
              placeholder="Search by Email..."
              value={search}
              onChange={handleSearchChange}
            />
          </div>
        </div>

        {/* Filter Buttons for Status */}
        <div className="tab_buttons">
          <Button
            className={
              statusFilter === "All"
                ? "newTabination-item active"
                : "newTabination-item"
            }
            onClick={() => handleFilterChange("All")}
          >
            All
          </Button>
          <Button
            className={
              statusFilter === "Paid"
                ? "newTabination-item active"
                : "newTabination-item"
            }
            onClick={() => handleFilterChange("Paid")}
          >
            Paid
          </Button>
          <Button
            className={
              statusFilter === "Pending"
                ? "newTabination-item active"
                : "newTabination-item"
            }
            onClick={() => handleFilterChange("Pending")}
          >
            Pending
          </Button>
          <Button
            className={
              statusFilter === "Failed"
                ? "newTabination-item active"
                : "newTabination-item"
            }
            onClick={() => handleFilterChange("Failed")}
          >
            Failed
          </Button>
        </div>
        <div className="mobileTabOption">
          <MobileTabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabItems={tabItems}
          />
        </div>
      </div>

      {filteredData.length ? (
        <>
          <BootstrapTable
            keyField="id"
            data={filteredData || []}
            columns={columns}
          />
          {/* Pagination Component */}
          <PaginationComponent
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            pageSize={rowsPerPage}
            setPageSize={setPageSize}
          />
        </>
      ) : (
        <p>No data available.</p>
      )}
    </div>
  );
};

export default CommissionPayment;
